export default "__VITE_ASSET__CucIrpoC__"